import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';

type SetIsDeepResearchArgs = { messageId: string };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const setIsDeepResearch: (args: SetIsDeepResearchArgs) => ChatMessageResearchStoreAction =
	({ messageId }: { messageId: string }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const currentState = getState();
		const message = currentState[messageId];

		setState({
			[messageId]: {
				...(message ?? { steps: {}, researchPlans: {} }),
				isDeepResearch: true,
			},
		});
	};
